export default "__VITE_ASSET__Prn4E4rR__"